module.exports = __webpack_public_path__ + "static/img/legend.0963a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend.png
// module id = OodW
// module chunks = 94